export default "__VITE_ASSET__de0dcd1f__"